/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
// Data
import {
  InformacionInicialUsuarios,
  InsertarUsuarios,
  UpdateStatusUsuario,
  ResetearContrasena,
} from "store/usuarios/usuariosActions";
import { InformacionInicialRoles } from "store/roles/rolesActions";
import ModalContent from "../../components/ModalContent";
import FormUsuario from "./formUsuario";
import Loading from "../../components/loading";
import Avatar from "@mui/material/Avatar";
import TableData from "./data/DataTableMaterial";
import { map } from "lodash";
import { Divider } from "@mui/material";
import toast from "react-hot-toast";
import { store } from "store/store";
import _ from "lodash";

function Usuarios() {
  //const {permisos} = useSelector((state) => state.roles);
  const usuario = store.getState().login.usuario;
  const { usuarios, isloadingAdd, isloadingUsuarios } = useSelector((state) => state.usuarios);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    InformacionInicialUsuarios(dispatch);
    InformacionInicialRoles(dispatch);
  }, []);

  const [nombre, setNombre] = useState("");
  const [apellioPaterno, setapellioPaterno] = useState("");
  const [apellioMaterno, setapellioMaterno] = useState("");
  const [rolUsuario, setrolUsuario] = useState(null);
  const [hospital, setHospital] = useState(null);
  const [correo, setcorreo] = useState("");
  const [celular, setcelular] = useState("");
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [permisos, setPermisos] = useState({});

  const [invalid_nombre, setInvalidNombre] = useState(false);
  const [invalid_apellioPaterno, setInvalidApellioPaterno] = useState(false);
  const [invalid_apellioMaterno, setInvalidApellioMaterno] = useState(false);
  const [invalid_rolUsuario, setInvalidRolUsuario] = useState(false);
  const [invalid_hospital, setInvalidHospital] = useState(false);
  const [invalid_correo, setInvalidCorreo] = useState(false);
  const [invalid_celular, setInvalidCelular] = useState(false);
  const [invalid_username, setInvalidUsername] = useState(false);
  const [invalid_password, setInvalidPassword] = useState(false);
  const [invalid_confirmpassword, setInvalidConfirmpassword] = useState(false);

  const [openmodalActivate, setopenmodalActivate] = useState(false);
  const [rowSelect, setrowSelect] = useState({});
  const [activarUsuario, setActivarUsuario] = useState(false);
  const [openmodal, setopenmodal] = useState(false);
  const [openmodalRestablecer, setopenmodalRestablecer] = useState(false);

  const usuariosMostrar = useMemo(() => {
    if (usuario.username != "soporte") {
      return usuarios.filter((obj) => obj.username !== "soporte");
    } else {
      return usuarios;
    }
  }, [usuarios]);

  const refresh = () => {
    setNombre("");
    setapellioPaterno("");
    setapellioMaterno("");
    setrolUsuario(null);
    setcorreo("");
    setcelular("");
    setusername("");
    setpassword("");
    setconfirmpassword("");
    setopenmodal(false);
    setInvalidNombre(false);
    setInvalidApellioPaterno(false);
    setInvalidApellioMaterno(false);
    setInvalidRolUsuario(false);
    setInvalidHospital(false);
    setInvalidCorreo(false);
    setInvalidCelular(false);
    setInvalidUsername(false);
    setInvalidPassword(false);
    setInvalidConfirmpassword(false);
  };

  const save = async () => {
    if (!nombre) {
      toast.error("Ingresar nombre del usuario");
      setInvalidNombre(true);
      return false;
    }
    if (!apellioPaterno) {
      toast.error("Ingresar el apellido paterno del usuario");
      setInvalidApellioPaterno(true);
      return false;
    }
    if (!rolUsuario) {
      toast.error("Seleccione rol para el usuario");
      setInvalidRolUsuario(true);
      return false;
    }
    // if (rolUsuario.rolUsuario != "Administración" && !hospital) {
    //   toast.error("Seleccione un hospital para el usuario");
    //   setInvalidHospital(true);
    //   return false;
    // }
    if (!correo) {
      toast.error("Ingrese el correo electrónico del usuario");
      setInvalidCorreo(true);
      return false;
    }
    if (!celular) {
      toast.error("Ingrese el celular del usuario");
      setInvalidCelular(true);
      return false;
    }
    if (!username) {
      toast.error("Ingrese el username para el usuario");
      setInvalidUsername(true);
      return false;
    }
    if (!password) {
      toast.error("Ingrese una contraseña para el usuario");
      setInvalidPassword(true);
      return false;
    }
    if (!confirmpassword) {
      toast.error("Ingrese la confirmación de la contraseña para el usuario");
      setInvalidConfirmpassword(true);
      return false;
    }
    if (password != confirmpassword) {
      toast.error("Las contraseñas no coinciden");
      return false;
    }

    const idPermisos = permisos ? map(permisos, (item) => item.idPermiso.toString()) : [];

    var data = {
      idUsuario: 0,
      username: username,
      password: password,
      nombre: nombre,
      apellioPaterno: apellioPaterno,
      apellioMaterno: apellioMaterno,
      rolUsuario: rolUsuario.rolUsuario,
      correo: correo,
      celular: celular,
      colorRol: rolUsuario.colorRol,
      firmaUsuario: "",
      idTipoUsuario: 3, //coorporativo
      idRolUsuario: rolUsuario.idRolUsuario,
      cadenaPermisos: "",
      heredarPermisos: true,
      permisos: idPermisos,
      userId: usuario.idUsuario, //El usuario logueado
      activo: true,
      idHospital: hospital ? hospital?.idHospital : 0,
      esAdmin: false,
    };
    const exito = await dispatch(InsertarUsuarios(data));
    setopenmodal(!exito);
  };

  const Author = ({ color, name, email, activo }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <Avatar sx={{ bgcolor: color, fontWeight: "bold", fontSize: 10 }}>{`${name.split(" ")[0][0]}${
        name.split(" ")[1][0]
      }`}</Avatar>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography
          display="block"
          variant="caption"
          fontWeight="medium"
          sx={{ color: `${activo ? "white" : "red"}`, fontSize: 11 }}
        >
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columnsUsuarios = useMemo(
    () => [
      {
        accessorKey: "avatar", //access nested data with dot notation
        header: "Usuario",
        size: 150,
        Cell: ({ row }) => {
          return (
            <Author
              color={row.original.colorRol}
              name={`${row.original.nombre} ${row.original.apellioPaterno} ${row.original.apellioMaterno}`}
              email={row.original.correo}
              activo={row.original.activo}
            />
          );
        },
      },
      {
        accessorKey: "username",
        header: "Username",
        size: 150,
      },
      {
        accessorKey: "rolUsuario", //normal accessorKey
        header: "Rol",
        size: 200,
        // Cell: ({ row }) => {
        //   return <RolAvatar color={row.original.colorRol} rolUsuario={row.original.rolUsuario} />;
        // },
      },
      {
        accessorKey: "celular",
        header: "Telefono",
        size: 150,
      },
    ],
    []
  );
  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const AdministrarUsuario = _.filter(usuarioPermisos, { idPermiso: 39 });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="primary"
                style={{ paddingTop: 10 }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDTypography variant="h6" color="white">
                      Administración de usuarios
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox textAlign="right">
                      {AdministrarUsuario.length == 0 ? null : (
                        <Button
                          variant="contained"
                          startIcon={<Icon>add</Icon>}
                          color="primary"
                          size="small"
                          style={{ textTransform: "inherit", background: "#1D1D1B" }}
                          onClick={() => {
                            setopenmodal(true);
                          }}
                        >
                          Nuevo
                        </Button>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <Divider />
              <MDBox pt={3}>
                {isloadingUsuarios ? (
                  <Loading title={"Procesando por favor espere"} />
                ) : (
                  <TableData
                    columns={columnsUsuarios}
                    data={usuariosMostrar}
                    EditarUsuario={(row) => {
                      const { avatar, ...safeRow } = row; // eliminar avatar
                      navigate("/modificarUsuario", { state: safeRow });
                    }}
                    ActivarUsuario={(row, active) => {
                      const { avatar, ...safeRow } = row;
                      setrowSelect(safeRow);
                      setActivarUsuario(active);
                      setopenmodalActivate(true);
                    }}
                    RestablecerContraseña={(row) => {
                      const { avatar, ...safeRow } = row;
                      setrowSelect(safeRow);
                      setopenmodalRestablecer(true);
                    }}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <ModalContent
        title={"Nuevo usuario"}
        maxWidth="sm"
        fullWidth={true}
        open={openmodal}
        fullScreen={false}
        handleClose={refresh}
        handleAcept={save}
        textAccept="Agregar"
      >
        {isloadingAdd ? (
          <Loading title={"Procesando por favor espere!"} />
        ) : (
          <FormUsuario
            vista={"creacion"}
            props={{
              nombre: nombre,
              apellioPaterno: apellioPaterno,
              apellioMaterno: apellioMaterno,
              rolUsuario: rolUsuario,
              hospital: hospital,
              correo: correo,
              celular: celular,
              username: username,
              password: password,
              confirmpassword: confirmpassword,
            }}
            invalids={{
              invalid_nombre: invalid_nombre,
              invalid_apellioPaterno: invalid_apellioPaterno,
              invalid_apellioMaterno: invalid_apellioMaterno,
              invalid_rolUsuario: invalid_rolUsuario,
              invalid_hospital: invalid_hospital,
              invalid_correo: invalid_correo,
              invalid_celular: invalid_celular,
              invalid_username: invalid_username,
              invalid_password: invalid_password,
              invalid_confirmpassword: invalid_confirmpassword,
            }}
            onChangeUser={(value, campo) => {
              if (campo === "nombre") setNombre(value);
              if (campo === "apellioPaterno") setapellioPaterno(value);
              if (campo === "apellioMaterno") setapellioMaterno(value);
              if (campo === "rolUsuario") setrolUsuario(value);
              if (campo === "hospital") setHospital(value);
              if (campo === "correo") setcorreo(value);
              if (campo === "celular") setcelular(value);
              if (campo === "username") setusername(value);
              if (campo === "password") setpassword(value);
              if (campo === "confirmpassword") setconfirmpassword(value);
              if (campo === "permisos") setPermisos(value);
            }}
            onChangeInvalid={(value, campo) => {
              if (campo === "nombre") setInvalidNombre(value);
              if (campo === "apellioPaterno") setInvalidApellioPaterno(value);
              if (campo === "apellioMaterno") setInvalidApellioMaterno(value);
              if (campo === "rolUsuario") setInvalidRolUsuario(value);
              if (campo === "hospital") setInvalidHospital(value);
              if (campo === "correo") setInvalidCorreo(value);
              if (campo === "celular") setInvalidCelular(value);
              if (campo === "username") setInvalidUsername(value);
              if (campo === "password") setInvalidPassword(value);
              if (campo === "confirmpassword") setInvalidConfirmpassword(value);
            }}
          />
        )}
      </ModalContent>
      <ModalContent
        title={"Modificar estatus del usuario"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalActivate}
        fullScreen={false}
        handleClose={() => {
          setopenmodalActivate(false);
        }}
        handleAcept={() => {
          UpdateStatusUsuario(dispatch, rowSelect, activarUsuario);
          setopenmodalActivate(false);
        }}
        textAccept={activarUsuario ? "Activar" : "Desactivar"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea {activarUsuario ? "activar" : "desactivar"} el usuario{" "}
            <strong>
              {`${rowSelect.nombre} ${rowSelect.apellioPaterno} ${rowSelect.apellioMaterno}`}
            </strong>
            ?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <ModalContent
        title={"Restablecer contraseña"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalRestablecer}
        fullScreen={false}
        handleClose={() => {
          setopenmodalRestablecer(false);
        }}
        handleAcept={() => {
          dispatch(ResetearContrasena(rowSelect.idUsuario));
          setopenmodalRestablecer(false);
        }}
        textAccept={"Aceptar"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            Esta acción cambiará la contraseña actual del usuario por una nueva la cual será enviada
            al correo electrónico registrado.
          </MDTypography>
        </MDBox>
      </ModalContent>
      <Footer />
    </DashboardLayout>
  );
}

export default Usuarios;
